/**
 * Chroniq's legal texts live in the Gastro Management portal, not in this app — mirrors
 * Chroniq/App-SPA/src/i18n/legal-links.ts (same group-wide document) and ScreenDeck's
 * identical `LegalLinksService`. One published version per document for the whole
 * group, always shown in full (no `?product=` selector any more — see
 * Portal/docs/done/KONZEPT-Produkt-Rechtsseiten.md); Portal-SPA only links out to it.
 */

const PORTAL = 'https://www.gastro-management.ch';

export type LegalDocument = 'privacy' | 'terms' | 'imprint';

/** German portal paths are the canonical public URLs. */
const PATHS: Record<LegalDocument, string> = {
  privacy: '/datenschutz',
  terms: '/agb',
  imprint: '/impressum',
};

// Portal-SPA has no i18n (Chef/Admin users, German-only UI) — unlike App-SPA/ScreenDeck,
// which pass the reader's browsing locale through.
export function legalUrl(document: LegalDocument): string {
  // The imprint is shared across the group's products and carries no anchor.
  if (document === 'imprint') {return `${PORTAL}${PATHS[document]}?lang=de`;}
  // #chroniq scrolls the reader straight to Chroniq's section of the always-complete document.
  return `${PORTAL}${PATHS[document]}?lang=de#chroniq`;
}
